import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/atoms/Button';
import { ROUTES } from '@/constants/routes';
import styles from './NotFoundPage.module.scss';

/**
 * Página 404 con la marca. Se monta en la ruta `*` (envuelta en
 * `AuthI18nLayout`, que aporta el `I18nextProvider`).
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.notFound}>
      <div className={styles.notFound__content}>
        <img
          className={styles.notFound__logo}
          src="/logo.svg"
          alt=""
          aria-hidden
          width={72}
          height={72}
        />
        <h1 className={styles.notFound__title}>{t('app.notFoundTitle')}</h1>
        <p className={styles.notFound__body}>{t('app.notFoundBody')}</p>
        <Button variant="primary" onClick={() => navigate(ROUTES.HOME)}>
          {t('app.notFoundHome')}
        </Button>
      </div>
    </div>
  );
}

export default NotFoundPage;
